import { ItrType, ProjectMilestoneType } from '@bechtel/types';
import { t } from '@lingui/macro';
import { ItrTypeExt } from './types';

export const itrTypeList: ItrTypeExt[] = [
  {
    description: t`Require foreman to certify pipe cleanliness for each spool as part of claiming progress milestone.`,
    value: ItrType.PIPE_CLEANLINESS,
  },
];

export const milestoneNoneType: ProjectMilestoneType = {
  id: 'None',
  name: 'None',
  itrRequired: false,
  projectItrConfig: [],
};

export const milestoneActionList = [
  { id: 1, value: 'CLAIM', name: 'Claim' },
  { id: 2, value: 'APPROVE', name: 'Approve' },
];

export const noItrMiestoneSelection = { id: 1, value: 'NONE', name: 'None' };
